export default __webpack_public_path__ + "static/mobcase1-e30270a4029566cd7b6c6fa68cee06ac.png";